module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kLOb0R/tc-custom/9781497613577.jpg?1737197408162",
      "alt": "This image is the cover for the book Castle Kidnapped, Castle Perilous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Castle Kidnapped, Castle Perilous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When the magical Castle Perilous goes haywire, guests find themselves venturing into bizarre other worlds that could bring the castle crumbling down.")]), _c('br'), _c('br'), _vm._v(" Castle Perilous is a magic castle full of mystery and adventure, but sometimes even magic castles can go awry. This particular castle has the power to send its guests to 144,000 alternate worlds, each a fantastic voyage to the unknown. But each voyage seems to backfire. Computer whiz kid Jeremy is stuck on a planet of golf-playing dinosaurs. Gentrified Gene finds himself on a planet overrun with amazon women where the queen has taken a particular shine to him and only the Lord of the Castle Incarnadine can stop this witty madness from shaking Castle Kidnapped to its foundations. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John DeChancie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining Castle series and the Starrigger trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0